/* VV_CART_A11Y 2026-10-12: keyboard + screen-reader support for #CartDrawer. No visual changes. */
(function () {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  var OPEN = 'drawer--is-open';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var lastOutside = null, opener = null, hidden = [], isOpen = false;

  drawer.setAttribute('role', 'dialog');
  drawer.setAttribute('aria-modal', 'true');
  if (!drawer.hasAttribute('aria-label')) drawer.setAttribute('aria-label', 'Cart');

  document.addEventListener('focusin', function (e) {
    if (!drawer.contains(e.target) && e.target !== document.body) lastOutside = e.target;
  }, true);
  document.addEventListener('pointerdown', function (e) {
    var el = e.target.closest && e.target.closest('a, button, input, [tabindex]');
    if (el && !drawer.contains(el)) lastOutside = el;
  }, true);

  function items() {
    return Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
    });
  }
  function hideBackground() {
    hidden = [];
    var node = drawer;
    while (node && node.parentElement && node !== document.body) {
      Array.prototype.forEach.call(node.parentElement.children, function (sib) {
        if (sib === node || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(sib.tagName)) return;
        if (sib.getAttribute('aria-hidden') === 'true') return;
        sib.setAttribute('aria-hidden', 'true');
        hidden.push(sib);
      });
      node = node.parentElement;
    }
  }
  function showBackground() {
    hidden.forEach(function (el) { el.removeAttribute('aria-hidden'); });
    hidden = [];
  }
  function onOpen() {
    isOpen = true;
    opener = lastOutside;
    hideBackground();
    setTimeout(function () {
      if (!isOpen || drawer.contains(document.activeElement)) return;
      var btn = drawer.querySelector('.js-drawer-close') || items()[0];
      if (btn) btn.focus();
    }, 50);
  }
  function onClose() {
    isOpen = false;
    showBackground();
    var target = opener;
    setTimeout(function () {
      var a = document.activeElement;
      if (target && document.contains(target) && (!a || a === document.body || drawer.contains(a))) {
        try { target.focus(); } catch (e) {}
      }
    }, 550);
  }
  new MutationObserver(function () {
    var now = drawer.classList.contains(OPEN);
    if (now && !isOpen) onOpen();
    else if (!now && isOpen) onClose();
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  if (drawer.classList.contains(OPEN)) onOpen();

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      var c = drawer.querySelector('.js-drawer-close');
      if (c) { e.preventDefault(); c.click(); }
      return;
    }
    if (e.key !== 'Tab') return;
    var list = items();
    if (!list.length) { e.preventDefault(); return; }
    var first = list[0], last = list[list.length - 1], a = document.activeElement;
    if (!drawer.contains(a)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }, true);
})();

/* VV_MOBILE_CART 2026-10-22: keeps body.cart-has-items + cart count bubbles in sync with the
   real cart (on load, back/forward, theme cart events, and any /cart/add|change|update|clear
   request; rebuilds the drawer via the theme's cart:build
   when the count changed outside the theme) so the phone cart button under the menu appears/disappears without a reload. */
(function () {
  if (window.__vvMobileCart) return; window.__vvMobileCart = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var origFetch = window.fetch;
  var last = null;
  function apply(n) {
    n = parseInt(n, 10) || 0;
    last = n;
    document.body.classList.toggle('cart-has-items', n > 0);
    document.querySelectorAll('.cart-link__bubble-num').forEach(function (e) { e.textContent = n; });
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) { b.classList.toggle('cart-link__bubble--visible', n > 0); });
    document.querySelectorAll('.site-nav__thumb-cart').forEach(function (a) {
      a.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    });
  }
  var t;
  function refresh() {
    clearTimeout(t);
    t = setTimeout(function () {
      (origFetch || fetch).call(window, root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (!c || typeof c.item_count !== 'number') return;
          var changed = last !== null && c.item_count !== last;
          apply(c.item_count);
          /* Cart changed outside the theme's own flow (e.g. an app's quick add):
             ask the theme to rebuild the drawer so tapping the icon shows the items. */
          if (changed) document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch(function () {});
    }, 120);
  }
  document.addEventListener('cart:updated', function (e) {
    var c = e && e.detail && e.detail.cart;
    if (c && typeof c.item_count === 'number') apply(c.item_count); else refresh();
  });
  document.addEventListener('ajaxProduct:added', refresh);
  if (origFetch) {
    window.fetch = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (CART_RE.test(u)) p.then(refresh, function () {});
      return p;
    };
  }
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (CART_RE.test(String(u || ''))) this.addEventListener('loadend', refresh);
    return origOpen.apply(this, arguments);
  };
  window.addEventListener('pageshow', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
